import { render, staticRenderFns } from "./WebupDetail.vue?vue&type=template&id=5421a995&scoped=true&"
import script from "./WebupDetail.vue?vue&type=script&lang=ts&"
export * from "./WebupDetail.vue?vue&type=script&lang=ts&"
import style0 from "./WebupDetail.vue?vue&type=style&index=0&id=5421a995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5421a995",
  null
  
)

export default component.exports